import API from "./index";

const contactAdmin = async (params) => {
  try {
    const { data } = await API.post("/contact", { ...params });
    return data;
  } catch (error) {
    console.log("Erro fetching data", error);
    return null;
  }
};

export { contactAdmin };
